import './_table-banner.scss';
import { FormatModule, Tabulator } from 'tabulator-tables';
import 'tabulator-tables/dist/css/tabulator_semanticui.css';
import { AV_LANGUAGES, DEFAULT_N_OF_PERIOD, DEFAULT_PERIOD, PERIOD_FILTERS, SPINNER_DURATION } from '@/ts/enums';
import { resolve } from '@/index';
import { replaceTimestamp } from '@/ts/utilities';
import {SearchableSelect} from "@/ts/utils/custom-select-full";

/*
* This function create the table with tabulator library.
* */

export default function TableBanner() {
    const $tableComponent = document.querySelectorAll('.table-banner');

    if ($tableComponent.length) {
        $tableComponent.forEach(($item: any) => {
            let data = [] as any;
            let timestamp: any;
            const $tablesWrapper = $item.querySelector('.tables-wrapper') as HTMLDivElement;
            const $tablesContent = $item.querySelectorAll('.tables-content');
            const htmlLang: any = (document.querySelector('html') as HTMLElement) ? (document.querySelector('html') as HTMLElement).getAttribute('lang') : '';
            const currentLanguage: string = htmlLang && AV_LANGUAGES.find(lang => lang.includes(htmlLang)) ? (AV_LANGUAGES.find(lang => lang.includes(htmlLang)) as string) : 'en-GB';
            let $filtersSelect = $item.querySelectorAll('.select-container');
            let initialDefaultPeriod = DEFAULT_PERIOD;
            let initialDefaultNumberOfPeriod = DEFAULT_N_OF_PERIOD;

            Tabulator.registerModule([FormatModule]);

            $tablesContent.forEach(($el: any) => {
                data.push([]);
            });

            bindInitialSelect();

            bindTable(initialDefaultPeriod, initialDefaultNumberOfPeriod);

            function initTable(data: any, index: number, isTableModal: boolean) {
                let totalVisits: any;
                const $tableLabel = $item.querySelectorAll('.table-label');
                let dataTable: any;
                if (data && data[index]) {
                    if (data[index].length > 5 && !isTableModal) {
                        if ($tablesContent.length) {
                            $tablesContent.forEach(($el: any, indexTable: number) => {
                                if (index === indexTable) {
                                    const $arrowLink = $el.querySelector('.link-arrow') as HTMLDivElement;
                                    $arrowLink && $arrowLink.classList.remove('d-none');
                                }
                            });
                        }
                        const maxColumns = data[index].slice(0, 5);
                        const orderedMaxColumns = maxColumns.sort((a: any, b: any) => b.visits - a.visits);
                        totalVisits = orderedMaxColumns.reduce((total: any, item: any) => total + item.visits, 0);
                        dataTable = orderedMaxColumns.map((item: any) => {
                            return {
                                label: currentLanguage === 'it-IT' ? item.label : item.labelEn || item.label,
                                total_value: item.visits.toLocaleString().replace(/,/g, '.') + ' ' + ($tableLabel && $tableLabel[index].textContent),
                                percentage: (item.visits / totalVisits) * 100,
                            };
                        });
                    } else {
                        if ($tablesContent.length) {
                            $tablesContent.forEach(($el: any, indexTable: number) => {
                                if (index === indexTable) {
                                    const $arrowLink = $el.querySelector('.link-arrow') as HTMLDivElement;
                                    $arrowLink && $arrowLink.classList.add('d-none');
                                }
                            });
                        }
                        const orderedMaxColumns = data[index].sort((a: any, b: any) => b.visits - a.visits);
                        totalVisits = orderedMaxColumns.reduce((total: any, item: any) => total + item.visits, 0);
                        dataTable = orderedMaxColumns.map((item: any) => {
                            return {
                                label: currentLanguage === 'it-IT' ? item.label : item.labelEn || item.label,
                                total_value: item.visits.toLocaleString().replace(/,/g, '.') + ' ' + ($tableLabel && $tableLabel[index].textContent),
                                percentage: (item.visits / totalVisits) * 100,
                            };
                        });
                    }

                    let temp = false;
                    let labelFind = false;
                    const columns =
                        dataTable && dataTable.length
                            ? Object.keys(dataTable[0])
                                  .map((key: string) => {
                                      if (!labelFind || !temp) {
                                          if (key === 'label') {
                                              labelFind = true;
                                          } else {
                                              temp = true;
                                          }

                                          return {
                                              title: key,
                                              field: key === 'percentage' || key === 'total_value' ? 'item' : key,
                                              formatter:
                                                  key === 'percentage' || key === 'total_value'
                                                      ? function (cell: any) {
                                                            let data = cell.getData();
                                                            let combinedValueText =
                                                                data.total_value + '<div class="progress--wrapper"><progress value="' + data.percentage + '" max="100"></progress></div>';
                                                            return '<div class="value-wrapper">' + combinedValueText + '</div>';
                                                        }
                                                      : '',
                                              widthGrow: key === 'label' ? 2 : 1,
                                          };
                                      } else return null;
                                  })
                                  .filter(el => !!el)
                            : [];

                    if ($tablesContent.length) {
                        $tablesContent.forEach(($el: any, indexTable: number) => {
                            const $tables = $el.querySelectorAll('.table');
                            if ($tables.length) {
                                $tables.forEach(($table: any) => {
                                    if (index === indexTable) {
                                        new Tabulator($table, {
                                            data: dataTable,
                                            columns: columns,
                                            layout: 'fitColumns',
                                            headerVisible: false,
                                            selectable: false,
                                        });
                                    }
                                });
                            }
                        });
                    }
                }
            }

            function ui() {
                if ($tablesContent.length) {
                    $tablesContent.forEach(($el: any, index: number) => {
                        const $modal = $el.querySelector('.modal') as HTMLDivElement;
                        const $lastUpdateDate = $modal.querySelector('.date.last-update') as HTMLDivElement;
                        const $closeModalBtn = $modal.querySelector('.close-btn') as HTMLDivElement;
                        const $btnShowMore = $el.querySelector('.link-arrow') as HTMLDivElement;

                        $btnShowMore.addEventListener('click', () => {
                            openModal($modal, index);
                        });

                        $btnShowMore.addEventListener('keypress', e => {
                            if (e.key === 'Enter') {
                                openModal($modal, index);
                                $closeModalBtn.focus();
                            }
                        });

                        $closeModalBtn.addEventListener('click', () => {
                            closeModal();
                        });

                        $closeModalBtn.addEventListener('keypress', e => {
                            if (e.key === 'Enter') {
                                closeModal();
                                $btnShowMore.focus();
                            }
                        });

                        document.addEventListener('click', event => {
                            if ($modal && !(event.target as HTMLElement).contains($modal)) return;
                            closeModal();
                        });

                        const date = new Date(timestamp);
                        const formattedDate = date.toLocaleDateString(currentLanguage, {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                        });

                        if ($lastUpdateDate) {
                            $lastUpdateDate.textContent = formattedDate;
                        }
                    });
                }
            }

            function closeModal() {
                if ($tablesContent.length) {
                    $tablesContent.forEach(($el: any, index: number) => {
                        const $modal = $el.querySelector('.modal') as HTMLDialogElement;
                        $modal.close();
                        ($modal.querySelector('.select-container')as HTMLSelectElement).removeAttribute('data-select-modal');

                        initTable(data, index, false);
                    });
                }
            }

            function openModal($modal: any, index: number) {
                $modal.querySelector('.select-container').setAttribute('data-select-modal', true);
                $modal.showModal();

                initTable(data, index, true);
            }

            function bindTable(period: string, numberOfPeriod: string, insideModal = false) {
                $item.classList.add('has-spinner');
                if ($tablesContent.length) {
                    $tablesContent.forEach(($el: any, index: number) => {
                        const $noResultTexts = $el.querySelectorAll('.no-result');
                        const dataApi = $el.getAttribute('data-api-table');

                        switch (dataApi) {
                            case 'DatasetTableProcedures':
                                try {
                                    resolve
                                        .run('getProcedures', period as any, numberOfPeriod as any)
                                        .then((res: any) => {
                                            if (!res.data) {
                                                throw new Error();
                                            } else {
                                                data[index] = res.data.list;
                                                timestamp = res.timestamp;

                                                setTimeout(() => {
                                                    $item.classList.remove('has-spinner');
                                                    ui();
                                                    initTable(data, index, insideModal);
                                                    if (data[index] && data[index].length) {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.add('d-none');
                                                        });
                                                        $el.classList.remove('no-result');
                                                    } else {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.remove('d-none');
                                                        });
                                                        $el.classList.add('no-result');
                                                    }
                                                }, SPINNER_DURATION);
                                            }
                                        })
                                        .catch(e => {
                                            //console.log(e);
                                            setTimeout(() => {
                                                $item.classList.remove('has-spinner');
                                                ui();
                                                initTable(data, index, insideModal);
                                                $noResultTexts.forEach(($noResultText: any) => {
                                                    $noResultText?.classList.remove('d-none');
                                                });
                                                $el.classList.add('no-result');
                                            }, SPINNER_DURATION);
                                        });
                                } catch (e) {
                                    $item.classList.remove('has-spinner');
                                    $tablesWrapper.classList.add('d-none');
                                    console.log(e);
                                }
                                break;

                            case 'DatasetTableSearches' :
                                try {
                                    resolve
                                        .run('getSearches', period as any, numberOfPeriod as any)
                                        .then((res: any) => {
                                            if (!res.data) {
                                                throw new Error();
                                            } else {
                                                data[index] = res.data.list;
                                                timestamp = res.timestamp;

                                                setTimeout(() => {
                                                    $item.classList.remove('has-spinner');
                                                    ui();
                                                    initTable(data, index, insideModal);
                                                    if (res.data.list && res.data.list.length) {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.add('d-none');
                                                        });
                                                        $el.classList.remove('no-result');
                                                    } else {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.remove('d-none');
                                                        });
                                                        $el.classList.add('no-result');
                                                    }
                                                }, SPINNER_DURATION);
                                            }
                                        })
                                        .catch(e => {
                                            //console.log(e);
                                            setTimeout(() => {
                                                $item.classList.remove('has-spinner');
                                                ui();
                                                initTable(data, index, insideModal);
                                                $noResultTexts.forEach(($noResultText: any) => {
                                                    $noResultText?.classList.remove('d-none');
                                                });
                                                $el.classList.add('no-result');
                                            }, SPINNER_DURATION);
                                        });
                                } catch (e) {
                                    $item.classList.remove('has-spinner');
                                    $tablesWrapper.classList.add('d-none');
                                    console.log(e);
                                }
                                break;

                            case 'DatasetTableLifeEvents' :
                                try {
                                    resolve
                                        .run('getLifeEvents', period as any, numberOfPeriod as any)
                                        .then((res: any) => {
                                            if (!res.data) {
                                                throw new Error();
                                            } else {
                                                data[index] = res.data.list;
                                                timestamp = res.timestamp;

                                                setTimeout(() => {
                                                    $item.classList.remove('has-spinner');
                                                    ui();
                                                    initTable(data, index, insideModal);
                                                    if (data[index] && data[index].length) {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.add('d-none');
                                                        });
                                                        $el.classList.remove('no-result');
                                                    } else {
                                                        $noResultTexts.forEach(($noResultText: any) => {
                                                            $noResultText?.classList.remove('d-none');
                                                        });
                                                        $el.classList.add('no-result');
                                                    }
                                                }, SPINNER_DURATION);
                                            }
                                        })
                                        .catch(e => {
                                            //console.log(e);
                                            setTimeout(() => {
                                                $item.classList.remove('has-spinner');
                                                ui();
                                                initTable(data, index, insideModal);
                                                $noResultTexts.forEach(($noResultText: any) => {
                                                    $noResultText?.classList.remove('d-none');
                                                });
                                                $el.classList.add('no-result');
                                            }, SPINNER_DURATION);
                                        });
                                } catch (e) {
                                    $item.classList.remove('has-spinner');
                                    $tablesWrapper.classList.add('d-none');
                                    console.log(e);
                                }
                                break;
                        }

                    });
                }
            }

            function updateSelects(period: any, NPeriod: any, type: any) {
                $filtersSelect.forEach(($select: any) => {
                    if ($select.getAttribute('data-select-type') === type) {
                        const $nativeSelect = $select.querySelector('select');

                        const $options = $nativeSelect.querySelectorAll('option');

                        $options.forEach(($option: any) => {
                            let optionValue = $option.value?.split('-') ? $option.value?.split('-') : $option.value?.split('-')[0];
                            $option.checked = optionValue === NPeriod && $option.getAttribute('data-type') === period;
                            $nativeSelect.value = NPeriod + '-' + period;
                        });

                        SearchableSelect.update($select);

                        $filtersSelect = $item.querySelectorAll('.select-container');

                        bindSelects();
                    }
                });
            }

            function bindSelects() {
                $filtersSelect.forEach(($select: any) => {
                    const $options = $select.querySelectorAll('.option-div');
                    const selectType = $select.getAttribute('data-select-type');

                    $options.forEach(($option: any) => {
                        $option.onclick = () => {
                            if (selectType === 'period') {
                                let numberOfPeriod = $option.getAttribute('option-id');
                                numberOfPeriod = numberOfPeriod && numberOfPeriod.split('-') ? numberOfPeriod.split('-')[0] : null;
                                const period = $option.getAttribute('data-type');
                                initialDefaultPeriod = period ? period : initialDefaultPeriod;
                                initialDefaultNumberOfPeriod = numberOfPeriod ? numberOfPeriod : initialDefaultNumberOfPeriod;
                            }

                            updateSelects(initialDefaultPeriod, initialDefaultNumberOfPeriod, selectType);

                            const selectModal = $item.querySelector('[data-select-modal]');
                            bindTable(initialDefaultPeriod, initialDefaultNumberOfPeriod, !!selectModal);
                        };
                    });
                });
            }

            function bindInitialSelect() {
                const filters = PERIOD_FILTERS || [];

                $filtersSelect.forEach(($select: any) => {
                    const selectType = $select.getAttribute('data-select-type');
                    if ($select.getAttribute('data-select-type') && $select.getAttribute('data-select-type') === selectType) {
                        const $nativeSelect = $select.querySelector('select');
                        filters.forEach((filterEL: any) => {
                            const $option = document.createElement('option') as HTMLOptionElement;
                            $option.setAttribute('value', filterEL.n_period + '-' + filterEL.period);
                            $option.setAttribute('data-type', filterEL.period);
                            $option.innerText = Drupal.t(filterEL.label);

                            $nativeSelect.appendChild($option);
                        });

                        SearchableSelect.init($nativeSelect, 'table-select');
                    }
                });

                $filtersSelect = $item.querySelectorAll('.select-container');

                bindSelects();
            }

            replaceTimestamp();
        });
    }
}
